// FarmSet / 行の生成ファクトリ（UI の新規作成・テストで使う）。
import { BASE_CURRENCY } from '../config';
import { newId } from './persist';
import { SCHEMA_VERSION } from './schema';
import type { CostLine, DropLine, FarmSet, GroupDrop } from './schema';

export function createFarmSet(league: string, displayUnit = 'divine'): FarmSet {
  return {
    schemaVersion: SCHEMA_VERSION,
    id: newId(),
    name: '新しいファーム',
    league,
    displayUnit,
    notes: '',
    time: 120,
    steady: { amount: 0, unit: BASE_CURRENCY },
    costLines: [],
    dropLines: [],
    updatedAt: Date.now(),
  };
}

export function createCostLine(): CostLine {
  return { id: newId(), name: '', role: 'cost', count: 1, unit: BASE_CURRENCY, value: 0 };
}

export function createDropLine(): DropLine {
  return {
    id: newId(),
    name: '',
    role: 'drop',
    count: 0.1,
    unit: BASE_CURRENCY,
    value: 0,
    rateMode: { kind: 'direct', lambda: 0.1 },
  };
}

export function createGroupDrop(): GroupDrop {
  return {
    kind: 'group',
    id: newId(),
    name: '',
    m: 1,
    members: [{ id: newId(), name: '', unit: BASE_CURRENCY, value: 0, p: 1 }],
  };
}
